<template>
  <section class="mo-search-input with-loader" :disabled="disabled">
    <div class="input-ctn">
      <input
        class="input"
        ref="input"
        type="text"
        :name="name"
        :disabled="disabled"
        :value="computedValue"
        @input="handleInput"
        @focus="handleFocus"
        @click="handleFocus"
        @paste="handleInput"
        @change="$emit('change')"
        @blur="handleLeave">
      <label class="label" :class="inputValue ? 'active' : ''">{{ label }}</label>
      <span class="error-msg" hidden>{{ errorMessage }}</span>
      <div class="dropdown" v-show="showDropdown">
        <ul>
          <li v-for="(option, idx) in filteredResults" :key="idx">
            <label>
              <input
                type="radio"
                :value="option.id"
                :name="`d-${name}`"
                v-model="selected"
                @click="selectItem(option)">{{ option.label }}</label>
          </li>
        </ul>
        <div class="footer-li" v-if="allowCreate"><label @click="handleCreate"><strong>"{{ inputValue }}"</strong> (créer)</label></div>
      </div>
    </div>
    <div class="loader-ctn">
      <div :class="loading ? 'loader' : ''"></div>
    </div>
  </section>
</template>

<script>
  import Fuse from 'fuse.js';
  import { setTimeout } from 'timers';
  export default {
    name: "mo-search-input",
    props: {
      options: {
        type: Array,
      },
      label: String,
      name: {
        type: String,
        default: ''
      },
      keys: Array,
      value: [ String, Number ],
      disabled: Boolean,
      allowCreate: {
        type: Boolean,
        default: true
      },
      errorMessage: String,
      initValue:{
        type: String,
        default: ''
      },
    },
    data() {
      return {
        inputValue: '',
        loading: false,
        edited: false,
        selected: this.value,
        focused: false,
        updateCpt:0
      }
    },
    created() {
        this.inputValue = this.initValue;
      this.initFuse();
    },
    computed: {
      computedValue() {
        // if (!this.options.length) return;
        const selectedItem = this.options.find(option => option.id == this.selected);
        return selectedItem && !this.edited ? selectedItem.label : this.inputValue;
      },
      filteredResults() {
        this.initFuse();
        if (!this.fuse) return [];
        // Empty the list when the input is 2 characters or less
    //  if (this.inputValue.length <= 2 && this.options.length) return [];
        if (this.inputValue.length == 0) return [];
        const result = this.inputValue ? this.fuse.search(this.inputValue) : [];
        setTimeout(() => this.loading = false, 3000)
        return result;
      },
      showDropdown() {
        if (!this.focused || this.inputValue.length < 2) return false;
        if (!this.allowCreate && !this.filteredResults.length) return false;
        return true;
      }
    },
    watch: {
      /**
       * When v-model is changed:
       *   1. Set internal value.
       */
      value(value) {
        this.selected = value;
      },
      options(value) {
        this.initFuse();
        this.updateCpt++;
      }
    },
    methods: {
      initFuse(force = null) {
          var data = this.options
          if(force != null) {
              data = force;
          }
         
            this.fuse = new Fuse(data, {
              matchAllTokens: true,
              findAllMatches: false,
              minMatchCharLength: 2,
              shouldSort: true,
              keys: this.keys,
              threshold: 0.1,
            });

            if (this.inputValue.length <= 2 && data.length) this.focused = true;
            this.inputValue ? this.fuse.search(this.inputValue) : [];
        
      },
      selectItem(option) {
        this.inputValue = option.label;
        this.$emit('input', option.id);
        this.$refs.input.focus();
        this.edited = false;
      },
      handleFocus(e) {
        this.focused = true;
        this.$emit('focus');
      },
      handleLeave(e) {
        this.$emit('blur');
        setTimeout(() => this.focused = false, 180);
      },
      async handleInput(e) {
        this.inputValue = e.target.value;
        if (this.inputValue.length > 2) {
          this.loading = true;
          this.$emit('searchText', this.inputValue);
        }
        this.edited = true
      },
      handleCreate(e) {
        this.$emit('create:new', this.inputValue);
      },
      reset() {
        this.inputValue = '';
      }
    }
  };
</script>

<style scoped>
  /* MD input */
  /* INPUT ------------------------------- */
  .mo-search-input {
    position: relative;
  }
  .with-loader { 
    display:flex;
    justify-content: space-between;
    align-items: center;
  }
  .input {
    background-color: var(--ba-input-bg-color, rgb(255, 255, 255));
    color: var(--ba-input-color, rgb(92, 92, 92));
    box-shadow: var(--ba-input-box-shadow, 0 1px 1px rgba(0,0,0,0.2));
    border-radius: 3px;
    border: 1px solid transparent;
    font-size: 1rem;
    text-indent: 5px;
    padding: 3px 0;
    display: block;
    width: 100%;
    box-sizing: border-box;
    text-align: inherit;
  }
  .input:focus { outline:none; }
  .input:disabled {
    background-color: #c4c4c44d;
  }
  /* LABEL ======================================= */
  .mo-search-input .label {
    position: absolute;
    color: var(--ba-input-label-color, rgb(92, 92, 92));
    font-weight: normal;
    font-size: 0.9rem;
    pointer-events: none;
    line-height: 1rem;
    top: var(--ba-input-label-position, -1rem);
    text-indent: 1px;
    will-change: transform;
    white-space: nowrap;
  }
  /*.mo-search-input[disabled] label { color: #cecece; }*/
  .mo-search-input.mandatory label::after {
    display: inline-block;
    margin-left: 0.1rem;
    line-height: 1rem;
    font-size: 1rem;
    color: var(--app-dark-grey);
    content: '*';
    vertical-align: middle;
  }
  /* active state */
  .mo-search-input.mandatory input:focus ~ label::after, .mo-search-input.mandatory .active::after {
    color: var(--ba-input-mandatory-label-color,  rgb(255, 56, 96));
  }
  .input:focus ~ label, .input:valid ~ .mo-search-input label, .mo-search-input .active {
    color: var(--mo-search-input-focus-color, rgb(92, 92, 92));
  }

  /* active state */
  .input:focus ~ .highlight {
    -webkit-animation:inputHighlighter 0.3s ease;
    -moz-animation:inputHighlighter 0.3s ease;
    animation:inputHighlighter 0.3s ease;
  }
  /* MD input */

  /* Icon-button */
  .icon-button {
    position: absolute;  
    display: inline-block;
    top: 0;
    right: 0;
  }
  .icon-button button {
    background: transparent;
    border: none;
    display: inline-block;
    cursor: pointer;
  }

  /* Dropdown */
  .dropdown {
    background-color: var(--app-input-dropdown-bg-color, rgb(255, 255, 255));
    position: absolute;
    z-index: 10;
    box-shadow: var(--ba-input-box-shadow, 0 1px 1px rgba(0,0,0,0.2));
    border-radius: 0 0 5px 5px;
    min-width: 100%;
  }

  .dropdown ul {
    list-style: none;
    font-size: 1rem;
    margin: 0;
    padding: 1rem 0;
    width: 100%;
    max-height: 20rem;
    overflow-y: auto;
  }
  .dropdown ul li {
    display: block;
    color: var(--ba-input-dropdown-element-color, rgb(92, 92, 92));
    font-weight: normal;
  }
  
  .dropdown ul li label,
  .footer-li label {
    display: flex;
    padding: 0.3rem 1rem;
    cursor: pointer;
  }
  .dropdown ul li:hover,
  .footer-li:hover {
    background-color: var(--app-dropdown-footer-bg-color, rgb(92, 92, 92));
    color: var(--app-dropdown-footer-color, rgb(255, 255, 255));
  }
  .footer-li {
    font-size: 1rem;
    margin-top: 1rem;
    font-weight: normal;
    margin-bottom: 0.4rem;
  }

  .dropdown input[type=radio] { display: none; }

  .input-ctn {
    flex: 1;
  }

  /* Loader */
  .loader-ctn {
    height: 2rem;
    width:  3rem;
  }
  .loader,
  .loader:before,
  .loader:after {
    background: #3273dc;
    -webkit-animation: load1 1s infinite ease-in-out;
    animation: load1 1s infinite ease-in-out;
    width: 1em;
    height: 1em;
  }
  .loader {
    color: #3273dc;
    text-indent: -9999em;
    margin: 3em auto;
    position: relative;
    font-size: 5px;
    -webkit-transform: translateZ(0);
    -ms-transform: translateZ(0);
    transform: translateZ(0);
    -webkit-animation-delay: -0.16s;
    animation-delay: -0.16s;
  }
  .loader:before,
  .loader:after {
    position: absolute;
    top: 0;
    content: '';
  }
  .loader:before {
    left: -1.5em;
    -webkit-animation-delay: -0.32s;
    animation-delay: -0.32s;
  }
  .loader:after {
    left: 1.5em;
  }
  @-webkit-keyframes load1 {
    0%,
    80%,
    100% {
      box-shadow: 0 0;
      height: 1em;
    }
    40% {
      box-shadow: 0 -2em;
      height: 2em;
    }
  }
  @keyframes load1 {
    0%,
    80%,
    100% {
      box-shadow: 0 0;
      height: 1em;
    }
    40% {
      box-shadow: 0 -2em;
      height: 2em;
    }
  }
</style>